import React from "react";
import HeroPoster from "./HeroPoster";

// Hero banners with order 2 (Admin -> Hero banners)
const Poster2 = () => <HeroPoster order={2} variant="poster2" />;

export default Poster2;
